import { FC } from 'react'
import { useNavigation } from 'react-router-dom'

/**
 * Slim top-of-page progress bar shown while React Router is loading a
 * route chunk (`route.lazy()`) between navigations. Reflects ONLY
 * router-level navigation state (`useNavigation().state`) — it must never
 * be driven by page-level `useQuery` loading states.
 */
const NavigationProgress: FC = () => {
  const navigation = useNavigation()
  const isNavigating = navigation.state === 'loading'

  if (!isNavigating) return null

  return (
    <div
      role='progressbar'
      aria-hidden='true'
      className='pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px] overflow-hidden bg-primary/20'
    >
      <div className='absolute h-full animate-nav-progress rounded-r-full bg-primary' />
    </div>
  )
}

export default NavigationProgress
